import IDesignationState,{IDesignationActionTypes,IDesignationActionCreator} from 'models/IDesginationState';

const initialState:IDesignationState[] = [];

const reducer = (state = initialState, { type, payload }: IDesignationActionCreator) => {
    switch (type) {
      case IDesignationActionTypes.FETCH_DESIGNATION_LIST_FAILURE:
        return {
          ...state,
          data:[],
        }
      case IDesignationActionTypes.FETCH_DESIGNATION_LIST_SUCCESS:
        return {
          ...state,
          data:payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;
